import React from 'react';

import { AuthProvider } from './auth';
import { AppStatusProvider } from './app';


const AppProvider = ({ children }) => (
  <AuthProvider>
    <AppStatusProvider>
      {children}
    </AppStatusProvider>
  </AuthProvider>
);

export default AppProvider;
